import { isNil, unionWith, eqBy, prop } from "ramda";
import moment from "moment";

import { SUPERADMIN } from "../constant/TypeRole";
import uploadService from "./uploadService";

const requesthandler = request => async (type, resource, params) => {
	if ((type === "CREATE" || type === "UPDATE") && resource === "interesting") {
		const { brochure, project_info, promotion, image } = params.data;
		if (brochure && project_info && image) {
			const newImage = await uploadService([image]);
			const newBrochure = await uploadService([brochure]);
			const project_info_file = await uploadService(project_info, "file");
			const newProject_info = await uploadService(project_info_file, "image");
			// const newArea_info = await uploadService(area_info, 'image')
			params.data = {
				...params.data,
				brochure: newBrochure,
				project_info: Array.isArray(newProject_info) ? newProject_info : [newProject_info],
				// area_info: Array.isArray(newArea_info) ? newArea_info : [newArea_info],
				// promotion: Array.isArray(newPromotion) ? newPromotion : [newPromotion],
				image: newImage
			};
		}
		if (promotion && promotion.length > 0) {
			const newPromotion = await uploadService(promotion, "image");
			params.data = {
				...params.data,
				promotion: Array.isArray(newPromotion) ? newPromotion : [newPromotion]
			};
		} else {
			params.data = {
				...params.data,
				promotion: []
			};
		}
	}
	if ((type === "CREATE" || type === "UPDATE") && resource === "project") {
		const { room_rates } = params.data;
		if (room_rates) {
			const newRoomRates = await uploadService([room_rates]);
			params.data = {
				...params.data,
				room_rates: newRoomRates,
			};
		}
	}
	if (type === "UPDATE" && resource === "repair") {
		if (params.data.message && params.data.message.image) {
			const newImage = await uploadService([params.data.message.image]);
			params.data = {
				...params.data,
				message: {
					...params.data.message,
					image: newImage
				}
			};
		}
	}
	if ((type === "CREATE" || type === "UPDATE") && resource === "room") {
		if (params.data.images) {
			params.data.images = await uploadService(Array.isArray ? params.data.images : [params.data.images]);
			params.data.images = Array.isArray(params.data.images) ? params.data.images : [params.data.images];
		}
	}
	if ((type === "CREATE" || type === "UPDATE") && resource === "project") {
		if (params.data.payment && params.data.payment.qr) {
			params.data.payment.qr = await uploadService([params.data.payment.qr]);
		}
	}
	if ((type === "UPDATE") && resource === "about") {
		if (params.data.about_file) {
			params.data.about_file = await uploadService([params.data.about_file]);
		}
	}
	if ((type === "CREATE" || type === "UPDATE")
		&& (resource === "announce" || resource === "market" || resource === "service"
			|| resource === "areainfo" || resource === "facilities" || resource === "message" || resource === "saleagency")) {
		const { image, file } = params.data;
		if (image) {
			const newImage = await uploadService([image]);
			params.data = { ...params.data, image: newImage };
		}
		if (file) {
			const newFile = await uploadService([file]);
			params.data = { ...params.data, file: newFile };
		}
	}
	if (type === "GET_LIST" && resource === "user") {
		if (params.filter && params.filter.q) {
			params.filter = { email_contains: params.filter.q };
		}
		if (params.filter.lastActive_gte) params.filter.lastActive_gte = moment(params.filter.lastActive_gte).startOf("day").format();
		if (params.filter.lastActive_lte) params.filter.lastActive_lte = moment(params.filter.lastActive_lte).endOf("day").format();
	}
	if (type === "CREATE" && resource === "user") {
		params.data = { ...params.data, username: params.data.email };
	}

	if (type === "GET_LIST" && resource === "room") {
		if (params.filter && params.filter.q) {
			params.filter = { ...params.filter, name_contains: params.filter.q };
			delete params.filter.q;
		}
	}
	if (type === "UPDATE" && resource === "room") {
		if (params.data && params.data.user) params.data.user = params.data.user._id;
	}
	if (type === "GET_LIST" && resource !== "user" && resource !== "project") {
		const role = localStorage.getItem("role");

		if (role !== SUPERADMIN && isNil(params.filter.project)) {
			const project = JSON.parse(localStorage.getItem("project"));
			params.filter.project = project;
		}
	}
	if (type === "GET_LIST" && resource === "facilitybooking") {
		if (params.filter.createdAt_gte) params.filter.createdAt_gte = moment(params.filter.createdAt_gte).startOf("day").format();
		if (params.filter.createdAt_lte) params.filter.createdAt_lte = moment(params.filter.createdAt_lte).endOf("day").format();
		// if (params.filter.booking_date) {
		// 	params.filter.booking_date_gt = params.filter.booking_date;
		// 	params.filter.booking_date_lt = moment(params.filter.booking_date, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD");
		// 	delete params.filter.booking_date;
		// }
	}
	if (type === "GET_LIST" && resource !== "project") {
		if (params.filter._id) delete params.filter._id;
	}
	if (type === "GET_LIST" && resource === "project") {
		if (params.filter.project) delete params.filter.project;
	}
	if (type === "GET_LIST" && (resource === "invoicelog" || resource === "invoice")) {
		if (params.filter.invoice_date_gte) params.filter.invoice_date_gte = moment(params.filter.invoice_date_gte).startOf("day").format();
		if (params.filter.invoice_date_lte) params.filter.invoice_date_lte = moment(params.filter.invoice_date_lte).endOf("day").format();
		if (params.filter.date_gte) params.filter.date_gte = moment(params.filter.date_gte).startOf("day").format();
		if (params.filter.date_lte) params.filter.date_lte = moment(params.filter.date_lte).endOf("day").format();
	}
	if ((type === "CREATE" || type === "UPDATE") && resource === "group") {
		params.data.users = unionWith(eqBy(prop("id")), [], params.data.users);
	}
	if ((type === "CREATE" || type === "UPDATE") && resource === "bill") {
		const { date } = params.data;
		params.data = { ...params.data, date: moment(date).endOf("month").format() };

		// if (!water_bill) params.data = { ...params.data, water_bill: 0 }
		// if (!electric_bill) params.data = { ...params.data, electric_bill: 0 }
		// if (!maintenance_fee) params.data = { ...params.data, maintenance_fee: 0 }
		// if (!installment) params.data = { ...params.data, installment: 0 }

		// if (water_bill_image) {
		//     const new_water = await uploadService([water_bill_image])
		//     params.data = { ...params.data, water_bill_image: new_water }
		// }
		// if (electric_bill_image) {
		//     const new_electric = await uploadService([electric_bill_image])
		//     params.data = { ...params.data, electric_bill_image: new_electric }
		// }
	}
	if (type === "GET_LIST" && resource === "repair") {
		if (params.filter.createdAt_gt) {
			params.filter.createdAt_gt = moment(params.filter.createdAt_gt, "YYYY-MM-DD").startOf("D").format();
		}
		if (params.filter.createdAt_lt) {
			params.filter.createdAt_lt = moment(params.filter.createdAt_lt, "YYYY-MM-DD").endOf("D").format();
		}
	}

	return request(type, resource, params);
};

export default requesthandler;


// WEBPACK FOOTER //
// ./src/services/requesthandler.js